var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7587_2097)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.2555 13.3188C50.9176 9.28867 47.7113 6.10469 43.7035 3.7668C39.6734 1.40664 35.2648 0.226562 30.5 0.226562C25.7352 0.226562 21.3266 1.40664 17.3188 3.74453C13.2887 6.10469 10.1047 9.28867 7.74453 13.3188C5.40664 17.3266 4.22656 21.7352 4.22656 26.5C4.22656 31.2648 5.40664 35.6734 7.74453 39.6812C10.0824 43.7113 13.2887 46.8953 17.2965 49.2332C21.3266 51.5934 25.7352 52.7734 30.5 52.7734C35.2648 52.7734 39.6734 51.5934 43.6812 49.2555C47.7113 46.9176 50.8953 43.7113 53.2332 39.7035C55.5711 35.6734 56.7512 31.2871 56.7512 26.5223C56.7734 21.7352 55.5934 17.3266 53.2555 13.3188ZM43.6367 28.3926L25.0227 39.3473C24.6887 39.5477 24.3102 39.659 23.9316 39.659C23.5754 39.659 23.1969 39.5699 22.8406 39.3918C22.1059 38.9688 21.7496 38.3231 21.7496 37.477V15.5453C21.7496 14.6992 22.1059 14.0758 22.8406 13.6305C23.5977 13.2074 24.3102 13.2297 25.0227 13.6527L43.6367 24.6074C44.3715 25.0305 44.7277 25.6539 44.7277 26.5C44.7277 27.3461 44.3715 27.9695 43.6367 28.3926Z",
    fill: "#ffffffe6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7587_2097",
    x: 0.226562,
    y: 0.226562,
    width: 60.5249,
    height: 60.5469,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7587_2097"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7587_2097",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.467b19aa.svg";
export { ForwardRef as ReactComponent };